// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*! tailwindcss v4.1.10 | MIT License | https://tailwindcss.com */
@layer properties;
@layer theme, base, components, utilities;
@layer theme {
  :root, :host {
    --font-sans: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji",
      "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
      "Courier New", monospace;
    --color-slate-50: oklch(98.4% 0.003 247.858);
    --color-slate-100: oklch(96.8% 0.007 247.896);
    --color-slate-300: oklch(86.9% 0.022 252.894);
    --color-slate-400: oklch(70.4% 0.04 256.788);
    --color-slate-500: oklch(55.4% 0.046 257.417);
    --color-slate-600: oklch(44.6% 0.043 257.281);
    --color-slate-700: oklch(37.2% 0.044 257.287);
    --color-slate-800: oklch(27.9% 0.041 260.031);
    --color-slate-900: oklch(20.8% 0.042 265.755);
    --color-slate-950: oklch(12.9% 0.042 264.695);
    --color-white: #fff;
    --spacing: 0.25rem;
    --text-xs: 0.75rem;
    --text-xs--line-height: calc(1 / 0.75);
    --text-sm: 0.875rem;
    --text-sm--line-height: calc(1.25 / 0.875);
    --text-base: 1rem;
    --text-base--line-height: calc(1.5 / 1);
    --text-lg: 1.125rem;
    --text-lg--line-height: calc(1.75 / 1.125);
    --text-xl: 1.25rem;
    --text-xl--line-height: calc(1.75 / 1.25);
    --text-2xl: 1.5rem;
    --text-2xl--line-height: calc(2 / 1.5);
    --text-3xl: 1.875rem;
    --text-3xl--line-height: calc(2.25 / 1.875);
    --text-5xl: 3rem;
    --font-weight-medium: 500;
    --font-weight-semibold: 600;
    --leading-snug: 1.375;
    --leading-normal: 1.5;
    --leading-relaxed: 1.625;
    --radius-sm: 0.25rem;
    --radius-lg: 0.5rem;
    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);
    --blur-sm: 8px;
    --blur-md: 12px;
    --default-transition-duration: 150ms;
    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    --default-font-family: var(--font-sans);
    --default-mono-font-family: var(--font-mono);
  }
}
@layer base {
  *, ::after, ::before, ::backdrop, ::file-selector-button {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    border: 0 solid;
  }
  html, :host {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
    font-family: var(--default-font-family, ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji");
    font-feature-settings: var(--default-font-feature-settings, normal);
    font-variation-settings: var(--default-font-variation-settings, normal);
    -webkit-tap-highlight-color: transparent;
  }
  hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
  abbr:where([title]) {
    -webkit-text-decoration: underline dotted;
    text-decoration: underline dotted;
  }
  h1, h2, h3, h4, h5, h6 {
    font-size: inherit;
    font-weight: inherit;
  }
  a {
    color: inherit;
    -webkit-text-decoration: inherit;
    text-decoration: inherit;
  }
  b, strong {
    font-weight: bolder;
  }
  code, kbd, samp, pre {
    font-family: var(--default-mono-font-family, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace);
    font-feature-settings: var(--default-mono-font-feature-settings, normal);
    font-variation-settings: var(--default-mono-font-variation-settings, normal);
    font-size: 1em;
  }
  small {
    font-size: 80%;
  }
  sub, sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
  sub {
    bottom: -0.25em;
  }
  sup {
    top: -0.5em;
  }
  table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
  :-moz-focusring {
    outline: auto;
  }
  progress {
    vertical-align: baseline;
  }
  summary {
    display: list-item;
  }
  ol, ul, menu {
    list-style: none;
  }
  img, svg, video, canvas, audio, iframe, embed, object {
    display: block;
    vertical-align: middle;
  }
  img, video {
    max-width: 100%;
    height: auto;
  }
  button, input, select, optgroup, textarea, ::file-selector-button {
    font: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    letter-spacing: inherit;
    color: inherit;
    border-radius: 0;
    background-color: transparent;
    opacity: 1;
  }
  :where(select:is([multiple], [size])) optgroup {
    font-weight: bolder;
  }
  :where(select:is([multiple], [size])) optgroup option {
    padding-inline-start: 20px;
  }
  ::file-selector-button {
    margin-inline-end: 4px;
  }
  ::placeholder {
    opacity: 1;
  }
  @supports (not (-webkit-appearance: -apple-pay-button))  or (contain-intrinsic-size: 1px) {
    ::placeholder {
      color: currentcolor;
      @supports (color: color-mix(in lab, red, red)) {
        color: color-mix(in oklab, currentcolor 50%, transparent);
      }
    }
  }
  textarea {
    resize: vertical;
  }
  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
  ::-webkit-date-and-time-value {
    min-height: 1lh;
    text-align: inherit;
  }
  ::-webkit-datetime-edit {
    display: inline-flex;
  }
  ::-webkit-datetime-edit-fields-wrapper {
    padding: 0;
  }
  ::-webkit-datetime-edit, ::-webkit-datetime-edit-year-field, ::-webkit-datetime-edit-month-field, ::-webkit-datetime-edit-day-field, ::-webkit-datetime-edit-hour-field, ::-webkit-datetime-edit-minute-field, ::-webkit-datetime-edit-second-field, ::-webkit-datetime-edit-millisecond-field, ::-webkit-datetime-edit-meridiem-field {
    padding-block: 0;
  }
  :-moz-ui-invalid {
    box-shadow: none;
  }
  button, input:where([type="button"], [type="reset"], [type="submit"]), ::file-selector-button {
    appearance: button;
  }
  ::-webkit-inner-spin-button, ::-webkit-outer-spin-button {
    height: auto;
  }
  [hidden]:where(:not([hidden="until-found"])) {
    display: none !important;
  }
}
@layer utilities {
  .visible {
    visibility: visible;
  }
  .absolute {
    position: absolute;
  }
  .fixed {
    position: fixed;
  }
  .relative {
    position: relative;
  }
  .static {
    position: static;
  }
  .inset-x-0 {
    inset-inline: calc(var(--spacing) * 0);
  }
  .top-0 {
    top: calc(var(--spacing) * 0);
  }
  .top-4 {
    top: calc(var(--spacing) * 4);
  }
  .left-4 {
    left: calc(var(--spacing) * 4);
  }
  .-z-1 {
    z-index: calc(1 * -1);
  }
  .z-0 {
    z-index: 0;
  }
  .z-1 {
    z-index: 1;
  }
  .container {
    width: 100%;
    @media (width >= 40rem) {
      max-width: 40rem;
    }
    @media (width >= 48rem) {
      max-width: 48rem;
    }
    @media (width >= 64rem) {
      max-width: 64rem;
    }
    @media (width >= 80rem) {
      max-width: 80rem;
    }
    @media (width >= 96rem) {
      max-width: 96rem;
    }
  }
  .mx-3 {
    margin-inline: calc(var(--spacing) * 3);
  }
  .my-3 {
    margin-block: calc(var(--spacing) * 3);
  }
  .my-6 {
    margin-block: calc(var(--spacing) * 6);
  }
  .mt-15 {
    margin-top: calc(var(--spacing) * 15);
  }
  .mt-\\[20px\\] {
    margin-top: 20px;
  }
  .mr-3 {
    margin-right: calc(var(--spacing) * 3);
  }
  .mb-10 {
    margin-bottom: calc(var(--spacing) * 10);
  }
  .ml-4 {
    margin-left: calc(var(--spacing) * 4);
  }
  .ml-10 {
    margin-left: calc(var(--spacing) * 10);
  }
  .block {
    display: block;
  }
  .flex {
    display: flex;
  }
  .grid {
    display: grid;
  }
  .hidden {
    display: none;
  }
  .inline-block {
    display: inline-block;
  }
  .size-full {
    width: 100%;
    height: 100%;
  }
  .min-h-\\[calc\\(100dvh-72px\\)\\] {
    min-height: calc(100dvh - 72px);
  }
  .w-8 {
    width: calc(var(--spacing) * 8);
  }
  .w-10 {
    width: calc(var(--spacing) * 10);
  }
  .w-full {
    width: 100%;
  }
  .max-w-\\[220px\\] {
    max-width: 220px;
  }
  .translate-y-3 {
    --tw-translate-y: calc(var(--spacing) * 3);
    translate: var(--tw-translate-x) var(--tw-translate-y);
  }
  .flex-col {
    flex-direction: column;
  }
  .items-center {
    align-items: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-center {
    justify-content: center;
  }
  .justify-items-center {
    justify-items: center;
  }
  .gap-4 {
    gap: calc(var(--spacing) * 4);
  }
  .gap-\\[56px\\] {
    gap: 56px;
  }
  .gap-x-2 {
    column-gap: calc(var(--spacing) * 2);
  }
  .gap-x-\\[40px\\] {
    column-gap: 40px;
  }
  .gap-y-5 {
    row-gap: calc(var(--spacing) * 5);
  }
  .self-center {
    align-self: center;
  }
  .justify-self-center {
    justify-self: center;
  }
  .justify-self-stretch {
    justify-self: stretch;
  }
  .scroll-smooth {
    scroll-behavior: smooth;
  }
  .rounded-sm {
    border-radius: var(--radius-sm);
  }
  .border-l-10 {
    border-left-style: var(--tw-border-style);
    border-left-width: 10px;
  }
  .border-slate-500 {
    border-color: var(--color-slate-500);
  }
  .bg-slate-500 {
    background-color: var(--color-slate-500);
  }
  .bg-white\\/20 {
    background-color: color-mix(in srgb, #fff 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 20%, transparent);
    }
  }
  .px-5 {
    padding-inline: calc(var(--spacing) * 5);
  }
  .px-10 {
    padding-inline: calc(var(--spacing) * 10);
  }
  .px-\\[8px\\] {
    padding-inline: 8px;
  }
  .px-\\[10px\\] {
    padding-inline: 10px;
  }
  .px-\\[20px\\] {
    padding-inline: 20px;
  }
  .py-5 {
    padding-block: calc(var(--spacing) * 5);
  }
  .py-\\[20px\\] {
    padding-block: 20px;
  }
  .pt-4 {
    padding-top: calc(var(--spacing) * 4);
  }
  .pt-\\[72px\\] {
    padding-top: 72px;
  }
  .pb-5 {
    padding-bottom: calc(var(--spacing) * 5);
  }
  .pb-10 {
    padding-bottom: calc(var(--spacing) * 10);
  }
  .pb-20 {
    padding-bottom: calc(var(--spacing) * 20);
  }
  .text-center {
    text-align: center;
  }
  .font-sans {
    font-family: var(--font-sans);
  }
  .text-base {
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
  }
  .text-base\\/normal {
    font-size: var(--text-base);
    line-height: var(--leading-normal);
  }
  .text-sm {
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
  }
  .text-xl {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
  }
  .font-medium {
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
  }
  .font-semibold {
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
  }
  .whitespace-nowrap {
    white-space: nowrap;
  }
  .text-slate-700 {
    color: var(--color-slate-700);
  }
  .text-white {
    color: var(--color-white);
  }
  .underline {
    text-decoration-line: underline;
  }
  .backdrop-blur-sm {
    --tw-backdrop-blur: blur(var(--blur-sm));
    -webkit-backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
    backdrop-filter: var(--tw-backdrop-blur,) var(--tw-backdrop-brightness,) var(--tw-backdrop-contrast,) var(--tw-backdrop-grayscale,) var(--tw-backdrop-hue-rotate,) var(--tw-backdrop-invert,) var(--tw-backdrop-opacity,) var(--tw-backdrop-saturate,) var(--tw-backdrop-sepia,);
  }
  .transition-colors {
    transition-property: color, background-color, border-color, outline-color, text-decoration-color, fill, stroke, --tw-gradient-from, --tw-gradient-via, --tw-gradient-to;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
  }
  .duration-300 {
    --tw-duration: 300ms;
    transition-duration: 300ms;
  }
  .hover\\:text-slate-950 {
    &:hover {
      @media (hover: hover) {
        color: var(--color-slate-950);
      }
    }
  }
  .sm\\:max-w-\\[260px\\] {
    @media (width >= 40rem) {
      max-width: 260px;
    }
  }
  .md\\:mr-10 {
    @media (width >= 48rem) {
      margin-right: calc(var(--spacing) * 10);
    }
  }
  .md\\:gap-x-5 {
    @media (width >= 48rem) {
      column-gap: calc(var(--spacing) * 5);
    }
  }
  .md\\:px-\\[50px\\] {
    @media (width >= 48rem) {
      padding-inline: 50px;
    }
  }
  .md\\:py-\\[18px\\] {
    @media (width >= 48rem) {
      padding-block: 18px;
    }
  }
  .md\\:text-center {
    @media (width >= 48rem) {
      text-align: center;
    }
  }
  .md\\:text-2xl {
    @media (width >= 48rem) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
  }
  .md\\:text-3xl {
    @media (width >= 48rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .lg\\:row-span-full {
    @media (width >= 64rem) {
      grid-row: 1 / -1;
    }
  }
  .lg\\:mt-\\[60px\\] {
    @media (width >= 64rem) {
      margin-top: 60px;
    }
  }
  .lg\\:ml-0 {
    @media (width >= 64rem) {
      margin-left: calc(var(--spacing) * 0);
    }
  }
  .lg\\:ml-15 {
    @media (width >= 64rem) {
      margin-left: calc(var(--spacing) * 15);
    }
  }
  .lg\\:min-h-\\[calc\\(100dvh-100px\\)\\] {
    @media (width >= 64rem) {
      min-height: calc(100dvh - 100px);
    }
  }
  .lg\\:w-10 {
    @media (width >= 64rem) {
      width: calc(var(--spacing) * 10);
    }
  }
  .lg\\:grid-flow-col {
    @media (width >= 64rem) {
      grid-auto-flow: column;
    }
  }
  .lg\\:grid-rows-\\[max-content_1fr\\] {
    @media (width >= 64rem) {
      grid-template-rows: max-content 1fr;
    }
  }
  .lg\\:justify-items-stretch {
    @media (width >= 64rem) {
      justify-items: stretch;
    }
  }
  .lg\\:gap-\\[80px\\] {
    @media (width >= 64rem) {
      gap: 80px;
    }
  }
  .lg\\:px-\\[50px\\] {
    @media (width >= 64rem) {
      padding-inline: 50px;
    }
  }
  .lg\\:pt-12 {
    @media (width >= 64rem) {
      padding-top: calc(var(--spacing) * 12);
    }
  }
  .lg\\:pt-\\[100px\\] {
    @media (width >= 64rem) {
      padding-top: 100px;
    }
  }
  .lg\\:pb-8 {
    @media (width >= 64rem) {
      padding-bottom: calc(var(--spacing) * 8);
    }
  }
  .lg\\:text-3xl {
    @media (width >= 64rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .lg\\:text-lg {
    @media (width >= 64rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
  }
  .lg\\:text-lg\\/normal {
    @media (width >= 64rem) {
      font-size: var(--text-lg);
      line-height: var(--leading-normal);
    }
  }
  .xl\\:top-5 {
    @media (width >= 80rem) {
      top: calc(var(--spacing) * 5);
    }
  }
  .xl\\:left-5 {
    @media (width >= 80rem) {
      left: calc(var(--spacing) * 5);
    }
  }
  .xl\\:row-span-full {
    @media (width >= 80rem) {
      grid-row: 1 / -1;
    }
  }
  .xl\\:mt-\\[130px\\] {
    @media (width >= 80rem) {
      margin-top: 130px;
    }
  }
  .xl\\:mr-30 {
    @media (width >= 80rem) {
      margin-right: calc(var(--spacing) * 30);
    }
  }
  .xl\\:max-w-\\[300px\\] {
    @media (width >= 80rem) {
      max-width: 300px;
    }
  }
  .xl\\:grid-flow-col {
    @media (width >= 80rem) {
      grid-auto-flow: column;
    }
  }
  .xl\\:grid-cols-\\[2fr_1fr\\] {
    @media (width >= 80rem) {
      grid-template-columns: 2fr 1fr;
    }
  }
  .xl\\:grid-rows-2 {
    @media (width >= 80rem) {
      grid-template-rows: repeat(2, minmax(0, 1fr));
    }
  }
  .xl\\:gap-\\[100px\\] {
    @media (width >= 80rem) {
      gap: 100px;
    }
  }
  .xl\\:gap-y-0 {
    @media (width >= 80rem) {
      row-gap: calc(var(--spacing) * 0);
    }
  }
  .xl\\:px-\\[150px\\] {
    @media (width >= 80rem) {
      padding-inline: 150px;
    }
  }
  .xl\\:text-3xl {
    @media (width >= 80rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  .xl\\:text-xl {
    @media (width >= 80rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .xl\\:text-xl\\/normal {
    @media (width >= 80rem) {
      font-size: var(--text-xl);
      line-height: var(--leading-normal);
    }
  }
}
@layer base {
  body {
    position: relative;
    min-height: 100vh;
    color: var(--color-slate-900);
  }
  body::before {
    position: absolute;
    inset: calc(var(--spacing) * 0);
    z-index: calc(2 * -1);
    background-color: var(--color-slate-900);
    --tw-content: '';
    content: var(--tw-content);
  }
  body::after {
    position: absolute;
    inset: calc(var(--spacing) * 0);
    z-index: calc(1 * -1);
    background-color: var(--color-white);
    --tw-blur: blur(var(--blur-sm));
    filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
    --tw-content: '';
    content: var(--tw-content);
    @media (width >= 64rem) {
      --tw-blur: blur(var(--blur-md));
      filter: var(--tw-blur,) var(--tw-brightness,) var(--tw-contrast,) var(--tw-grayscale,) var(--tw-hue-rotate,) var(--tw-invert,) var(--tw-saturate,) var(--tw-sepia,) var(--tw-drop-shadow,);
    }
  }
  h1,
  h2,
  h3,
  h4 {
    color: var(--color-slate-950);
  }
  h2 {
    padding-top: calc(var(--spacing) * 20);
    font-size: var(--text-2xl);
    line-height: var(--leading-snug);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    @media (width >= 64rem) {
      font-size: var(--text-5xl);
      line-height: var(--leading-snug);
    }
  }
  h3 {
    font-size: var(--text-xl);
    line-height: var(--tw-leading, var(--text-xl--line-height));
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    @media (width >= 64rem) {
      font-size: var(--text-3xl);
      line-height: var(--tw-leading, var(--text-3xl--line-height));
    }
  }
  h4 {
    margin-inline: calc(var(--spacing) * 5);
    margin-top: calc(var(--spacing) * 6);
    justify-self: stretch;
    border-left-style: var(--tw-border-style);
    border-left-width: 3px;
    padding-block: calc(var(--spacing) * 1);
    padding-left: calc(var(--spacing) * 5);
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    color: var(--color-white);
    @media (width >= 64rem) {
      font-size: var(--text-2xl);
      line-height: var(--tw-leading, var(--text-2xl--line-height));
    }
  }
  figure {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  figure > img {
    height: 30px;
    @media (width >= 64rem) {
      height: 60px;
    }
  }
  figcaption {
    text-align: center;
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--color-slate-500);
    @media (width >= 64rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  address {
    margin-inline: calc(var(--spacing) * 3);
    margin-block: calc(var(--spacing) * 5);
    display: grid;
    grid-template-columns: repeat(auto-fill,minmax(150px,1fr));
    row-gap: calc(var(--spacing) * 5);
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    font-style: normal;
    @media (width >= 64rem) {
      margin-inline: calc(var(--spacing) * 0);
    }
  }
  address a {
    display: flex;
    align-items: center;
    gap: calc(var(--spacing) * 2);
  }
  address img {
    width: 30px;
  }
}
@layer components {
  .progress-bar::before {
    position: absolute;
    inset-inline: 15px;
    bottom: calc(var(--spacing) * 0);
    height: min-content;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 0.5px;
    border-color: color-mix(in srgb, oklch(55.4% 0.046 257.417) 50%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-slate-500) 50%, transparent);
    }
    --tw-content: '';
    content: var(--tw-content);
    @media (width >= 64rem) {
      inset-inline: 50px;
    }
  }
  .progress-bar::after {
    position: absolute;
    inset-inline: 15px;
    bottom: calc(var(--spacing) * 0);
    height: 2px;
    background-color: var(--color-slate-950);
    --tw-content: '';
    content: var(--tw-content);
    @media (width >= 64rem) {
      inset-inline: 50px;
    }
    transform-origin: center left;
    animation: progress linear;
    animation-timeline: scroll(root block);
  }
  .shadowing {
    border: 1px solid rgba(255, 255, 255, 0.16);
    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.12);
  }
  .cta-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    text-align: center;
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 300ms;
    transition-duration: 300ms;
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus-visible {
      --tw-ring-color: color-mix(in srgb, oklch(12.9% 0.042 264.695) 25%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-slate-950) 25%, transparent);
      }
    }
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
    &:focus-visible {
      --tw-ring-offset-color: var(--color-white);
    }
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
    padding: 7px 25px;
  }
  .cta-button--primary {
    border-color: var(--color-slate-500);
    background-color: var(--color-slate-500);
    color: var(--color-white);
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
    &:hover {
      @media (hover: hover) {
        border-color: var(--color-slate-600);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-slate-600);
      }
    }
    box-shadow: none;
  }
  .cta-button--secondary {
    border-color: var(--color-slate-400);
    background-color: color-mix(in srgb, #fff 35%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 35%, transparent);
    }
    color: var(--color-slate-900);
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 55%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 55%, transparent);
        }
      }
    }
    backdrop-filter: blur(10px);
    box-shadow: none;
  }
  .footer-pill {
    display: inline-block;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: var(--color-slate-400);
    background-color: color-mix(in srgb, #fff 35%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 35%, transparent);
    }
    font-size: var(--text-xs);
    line-height: var(--tw-leading, var(--text-xs--line-height));
    color: var(--color-slate-900);
    @media (width >= 64rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
    padding: 6px 25px;
    backdrop-filter: blur(10px);
    box-shadow: inset 0 1px 3px rgba(255, 255, 255, 0.18),
      0 4px 10px rgba(15, 23, 42, 0.1);
  }
  .separator {
    position: relative;
  }
  .separator::before {
    position: absolute;
    inset-inline: 40%;
    height: min-content;
    border-top-style: var(--tw-border-style);
    border-top-width: 10px;
    --tw-border-style: double;
    border-style: double;
    border-color: var(--color-slate-500);
    --tw-content: '';
    content: var(--tw-content);
  }
  #projects,
  #blog,
  #contact {
    padding-inline: 20px;
    @media (width >= 64rem) {
      padding-inline: 100px;
    }
  }
  #projects article {
    display: grid;
    width: 100%;
    max-width: 600px;
    align-items: flex-start;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
    background-color: var(--color-slate-500);
    color: var(--color-white);
    box-shadow: 0 16px 32px rgba(15, 23, 42, 0.08);
  }
  #projects > div {
    margin-inline: calc(var(--spacing) * 1);
    display: grid;
    justify-items: center;
    row-gap: calc(var(--spacing) * 10);
    @media (width >= 64rem) {
      margin-inline: calc(var(--spacing) * 3);
    }
  }
  #projects .embla__viewport {
    border-top-left-radius: var(--radius-lg);
    border-top-right-radius: var(--radius-lg);
  }
  #projects article > ul {
    list-style-type: disc;
    padding-block: calc(var(--spacing) * 2);
    padding-right: calc(var(--spacing) * 5);
    padding-left: calc(var(--spacing) * 10);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    @media (width >= 64rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .project-actions {
    margin-inline: calc(var(--spacing) * 4);
    display: grid;
    gap: calc(var(--spacing) * 3);
    border-top-style: var(--tw-border-style);
    border-top-width: 1px;
    border-color: color-mix(in srgb, #fff 20%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 20%, transparent);
    }
    padding-top: calc(var(--spacing) * 5);
    padding-bottom: calc(var(--spacing) * 5);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 64rem) {
      margin-inline: calc(var(--spacing) * 5);
    }
    @media (width >= 64rem) {
      grid-template-columns: repeat(2, minmax(0, 1fr));
    }
    @media (width >= 64rem) {
      gap: calc(var(--spacing) * 4);
    }
    @media (width >= 64rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
  }
  .project-action {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: calc(var(--spacing) * 2);
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    padding-inline: calc(var(--spacing) * 4);
    padding-block: calc(var(--spacing) * 2);
    text-align: center;
    --tw-font-weight: var(--font-weight-medium);
    font-weight: var(--font-weight-medium);
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 300ms;
    transition-duration: 300ms;
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
    &:focus-visible {
      --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
      box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    }
    &:focus-visible {
      --tw-ring-color: color-mix(in srgb, #fff 70%, transparent);
      @supports (color: color-mix(in lab, red, red)) {
        --tw-ring-color: color-mix(in oklab, var(--color-white) 70%, transparent);
      }
    }
    &:focus-visible {
      --tw-ring-offset-width: 2px;
      --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    }
    &:focus-visible {
      --tw-ring-offset-color: var(--color-slate-500);
    }
    &:focus-visible {
      --tw-outline-style: none;
      outline-style: none;
    }
  }
  .project-action--primary {
    border-color: var(--color-white);
    background-color: var(--color-white);
    color: var(--color-slate-800);
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-slate-100);
      }
    }
  }
  .project-action--secondary {
    border-color: color-mix(in srgb, #fff 45%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 45%, transparent);
    }
    background-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      background-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
    color: var(--color-white);
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -0.5);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
    &:hover {
      @media (hover: hover) {
        border-color: color-mix(in srgb, #fff 70%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          border-color: color-mix(in oklab, var(--color-white) 70%, transparent);
        }
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: color-mix(in srgb, #fff 15%, transparent);
        @supports (color: color-mix(in lab, red, red)) {
          background-color: color-mix(in oklab, var(--color-white) 15%, transparent);
        }
      }
    }
    backdrop-filter: blur(10px);
  }
  .project-action__icon {
    display: inline-block;
    width: 18px;
    @media (width >= 64rem) {
      width: 20px;
    }
    filter: brightness(0) saturate(100%);
  }
  .project-action i {
    font-size: var(--text-lg);
    line-height: var(--tw-leading, var(--text-lg--line-height));
    @media (width >= 64rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  .white-icon {
    filter: brightness(0) invert(1);
    display: inline-block;
    width: 20px;
  }
  .big-icon {
    filter: brightness(0) invert(1);
    display: inline-block;
    width: 25px;
    @media (width >= 64rem) {
      width: 30px;
    }
  }
  #projects > h2,
  #blog > h2 {
    width: 200px;
    border-bottom-style: var(--tw-border-style);
    border-bottom-width: 8px;
    border-color: var(--color-slate-500);
    padding-bottom: calc(var(--spacing) * 3);
    white-space: nowrap;
  }
  #projects h3 {
    margin: calc(var(--spacing) * 5);
    width: 200px;
    border-top-left-radius: var(--radius-lg);
    border-top-style: var(--tw-border-style);
    border-top-width: 6px;
    border-left-style: var(--tw-border-style);
    border-left-width: 6px;
    border-color: var(--color-slate-500);
    padding-block: calc(var(--spacing) * 3);
    padding-left: calc(var(--spacing) * 2);
    white-space: nowrap;
    @media (width >= 64rem) {
      padding-left: calc(var(--spacing) * 5);
    }
  }
  .project-tools {
    display: flex;
    flex-wrap: wrap;
    column-gap: calc(var(--spacing) * 3);
    row-gap: calc(var(--spacing) * 1);
    padding-inline: calc(var(--spacing) * 5);
    padding-bottom: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    @media (width >= 64rem) {
      column-gap: calc(var(--spacing) * 5);
    }
    @media (width >= 64rem) {
      row-gap: calc(var(--spacing) * 1);
    }
    @media (width >= 64rem) {
      padding-bottom: calc(var(--spacing) * 3);
    }
    @media (width >= 64rem) {
      font-size: var(--text-lg);
      line-height: var(--tw-leading, var(--text-lg--line-height));
    }
  }
  .center-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
  }
  .blog-state {
    margin-inline: calc(var(--spacing) * 1);
    margin-bottom: calc(var(--spacing) * 10);
    text-align: center;
    font-size: var(--text-base);
    line-height: var(--tw-leading, var(--text-base--line-height));
    color: var(--color-slate-700);
    @media (width >= 64rem) {
      margin-inline: calc(var(--spacing) * 3);
    }
    @media (width >= 64rem) {
      font-size: var(--text-xl);
      line-height: var(--tw-leading, var(--text-xl--line-height));
    }
  }
  #blog-posts {
    margin-inline: calc(var(--spacing) * 1);
    display: grid;
    justify-items: center;
    row-gap: calc(var(--spacing) * 10);
    @media (width >= 64rem) {
      margin-inline: calc(var(--spacing) * 3);
    }
  }
  #blog article {
    width: 100%;
    max-width: 600px;
    border-radius: var(--radius-lg);
    border-style: var(--tw-border-style);
    border-width: 1px;
    border-color: color-mix(in srgb, #fff 10%, transparent);
    @supports (color: color-mix(in lab, red, red)) {
      border-color: color-mix(in oklab, var(--color-white) 10%, transparent);
    }
    background-color: var(--color-slate-500);
    color: var(--color-white);
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 300ms;
    transition-duration: 300ms;
    --tw-ease: var(--ease-in-out);
    transition-timing-function: var(--ease-in-out);
    &:hover {
      @media (hover: hover) {
        --tw-translate-y: calc(var(--spacing) * -1);
        translate: var(--tw-translate-x) var(--tw-translate-y);
      }
    }
    &:hover {
      @media (hover: hover) {
        background-color: var(--color-slate-600);
      }
    }
    box-shadow: 0 16px 32px rgba(15, 23, 42, 0.08);
  }
  #blog article > a {
    display: block;
    border-radius: var(--radius-lg);
    padding: calc(var(--spacing) * 4);
    @media (width >= 64rem) {
      padding: calc(var(--spacing) * 6);
    }
  }
  #blog article > a:focus-visible {
    border-radius: var(--radius-lg);
    --tw-ring-shadow: var(--tw-ring-inset,) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color, currentcolor);
    box-shadow: var(--tw-inset-shadow), var(--tw-inset-ring-shadow), var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow);
    --tw-ring-color: var(--color-white);
    --tw-ring-offset-width: 2px;
    --tw-ring-offset-shadow: var(--tw-ring-inset,) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-offset-color: var(--color-slate-500);
    --tw-outline-style: none;
    outline-style: none;
  }
  #blog article h3 {
    font-size: var(--text-2xl);
    line-height: var(--leading-snug);
    --tw-font-weight: var(--font-weight-semibold);
    font-weight: var(--font-weight-semibold);
    color: var(--color-white);
    transition-property: all;
    transition-timing-function: var(--tw-ease, var(--default-transition-timing-function));
    transition-duration: var(--tw-duration, var(--default-transition-duration));
    --tw-duration: 300ms;
    transition-duration: 300ms;
    @media (width >= 64rem) {
      font-size: var(--text-3xl);
      line-height: var(--leading-snug);
    }
  }
  #blog article:hover h3 {
    text-decoration-line: underline;
    text-underline-offset: 4px;
  }
  .blog-card__meta {
    margin-top: calc(var(--spacing) * 2);
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    column-gap: calc(var(--spacing) * 3);
    row-gap: calc(var(--spacing) * 1);
    font-size: var(--text-sm);
    line-height: var(--tw-leading, var(--text-sm--line-height));
    color: var(--color-slate-100);
    @media (width >= 64rem) {
      font-size: var(--text-base);
      line-height: var(--tw-leading, var(--text-base--line-height));
    }
  }
  .blog-card__separator {
    color: var(--color-slate-300);
  }
  .blog-card__subtitle {
    margin-top: calc(var(--spacing) * 2);
    font-size: var(--text-base);
    line-height: var(--leading-relaxed);
    color: var(--color-slate-50);
    @media (width >= 64rem) {
      font-size: var(--text-lg);
      line-height: var(--leading-relaxed);
    }
  }
  .embla {
    position: relative;
  }
  .embla__viewport {
    overflow: hidden;
  }
  .embla__container {
    display: flex;
    touch-action: pan-y pinch-zoom;
  }
  .embla__slide {
    flex: 0 0 100%;
    min-width: 0;
    object-fit: cover;
  }
  .embla__prev {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
  .embla__next {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
  }
}
@keyframes progress {
  from {
    transform: scaleX(0);
  }
}
@property --tw-translate-x {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-y {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-translate-z {
  syntax: "*";
  inherits: false;
  initial-value: 0;
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-backdrop-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-duration {
  syntax: "*";
  inherits: false;
}
@property --tw-content {
  syntax: "*";
  inherits: false;
  initial-value: "";
}
@property --tw-blur {
  syntax: "*";
  inherits: false;
}
@property --tw-brightness {
  syntax: "*";
  inherits: false;
}
@property --tw-contrast {
  syntax: "*";
  inherits: false;
}
@property --tw-grayscale {
  syntax: "*";
  inherits: false;
}
@property --tw-hue-rotate {
  syntax: "*";
  inherits: false;
}
@property --tw-invert {
  syntax: "*";
  inherits: false;
}
@property --tw-opacity {
  syntax: "*";
  inherits: false;
}
@property --tw-saturate {
  syntax: "*";
  inherits: false;
}
@property --tw-sepia {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-drop-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-drop-shadow-size {
  syntax: "*";
  inherits: false;
}
@property --tw-ease {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-inset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-shadow-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-shadow-alpha {
  syntax: "<percentage>";
  inherits: false;
  initial-value: 100%;
}
@property --tw-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-inset-ring-color {
  syntax: "*";
  inherits: false;
}
@property --tw-inset-ring-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@property --tw-ring-inset {
  syntax: "*";
  inherits: false;
}
@property --tw-ring-offset-width {
  syntax: "<length>";
  inherits: false;
  initial-value: 0px;
}
@property --tw-ring-offset-color {
  syntax: "*";
  inherits: false;
  initial-value: #fff;
}
@property --tw-ring-offset-shadow {
  syntax: "*";
  inherits: false;
  initial-value: 0 0 #0000;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-translate-x: 0;
      --tw-translate-y: 0;
      --tw-translate-z: 0;
      --tw-border-style: solid;
      --tw-font-weight: initial;
      --tw-backdrop-blur: initial;
      --tw-backdrop-brightness: initial;
      --tw-backdrop-contrast: initial;
      --tw-backdrop-grayscale: initial;
      --tw-backdrop-hue-rotate: initial;
      --tw-backdrop-invert: initial;
      --tw-backdrop-opacity: initial;
      --tw-backdrop-saturate: initial;
      --tw-backdrop-sepia: initial;
      --tw-duration: initial;
      --tw-content: "";
      --tw-blur: initial;
      --tw-brightness: initial;
      --tw-contrast: initial;
      --tw-grayscale: initial;
      --tw-hue-rotate: initial;
      --tw-invert: initial;
      --tw-opacity: initial;
      --tw-saturate: initial;
      --tw-sepia: initial;
      --tw-drop-shadow: initial;
      --tw-drop-shadow-color: initial;
      --tw-drop-shadow-alpha: 100%;
      --tw-drop-shadow-size: initial;
      --tw-ease: initial;
      --tw-shadow: 0 0 #0000;
      --tw-shadow-color: initial;
      --tw-shadow-alpha: 100%;
      --tw-inset-shadow: 0 0 #0000;
      --tw-inset-shadow-color: initial;
      --tw-inset-shadow-alpha: 100%;
      --tw-ring-color: initial;
      --tw-ring-shadow: 0 0 #0000;
      --tw-inset-ring-color: initial;
      --tw-inset-ring-shadow: 0 0 #0000;
      --tw-ring-inset: initial;
      --tw-ring-offset-width: 0px;
      --tw-ring-offset-color: #fff;
      --tw-ring-offset-shadow: 0 0 #0000;
    }
  }
}
`, "",{"version":3,"sources":["<no source>","webpack://./node_modules/tailwindcss/index.css","webpack://./src/styles.css"],"names":[],"mappings":"AAAA,kEAAA;ACs3BE,iBAAmB;AAt3BrB,yCAAyC;AAEzC;EACE;IACE;6DAEyD;IAEzD;8BAE0B;IA8M1B,4CAA4C;IAC5C,6CAA6C;IAE7C,6CAA6C;IAC7C,4CAA4C;IAC5C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAC7C,6CAA6C;IAmD7C,mBAAmB;IAEnB,kBAAkB;IAsBlB,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;IACnB,0CAA0C;IAC1C,iBAAiB;IACjB,uCAAuC;IACvC,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,yCAAyC;IACzC,kBAAkB;IAClB,sCAAsC;IACtC,oBAAoB;IACpB,2CAA2C;IAG3C,gBAAgB;IAehB,yBAAyB;IACzB,2BAA2B;IAa3B,qBAAqB;IACrB,qBAAqB;IACrB,wBAAwB;IAIxB,oBAAoB;IAEpB,mBAAmB;IA0CnB,2CAA2C;IAyC3C,cAAc;IACd,eAAe;IAcf,oCAAoC;IACpC,kEAAkE;IAClE,uCAAoD;IASpD,4CAAyD;EA5c5C;AADJ;AAmeb;EAOE;IAKE,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,eAAe;EAJM;EAiBvB;IAEE,gBAAgB;IAChB,8BAA8B;IAC9B,WAAW;IACX,2JASC;IACD,mEAGC;IACD,uEAGC;IACD,wCAAwC;EAtBpC;EA+BN;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EAHpB;EAUH;IACE,yCAAyC;IACzC,iCAAiC;EAFf;EASpB;IAME,kBAAkB;IAClB,oBAAoB;EAFnB;EASH;IACE,cAAc;IACd,gCAAgC;IAChC,wBAAwB;EAHxB;EAUF;IAEE,mBAAmB;EADd;EAWP;IAIE,gJAUC;IACD,wEAGC;IACD,4EAGC;IACD,cAAc;EApBZ;EA2BJ;IACE,cAAc;EADV;EAQN;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAJtB;EAOJ;IACE,eAAe;EADb;EAIJ;IACE,WAAW;EADT;EAUJ;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAHrB;EAUN;IACE,aAAa;EADC;EAQhB;IACE,wBAAwB;EADjB;EAQT;IACE,kBAAkB;EADZ;EAQR;IAGE,gBAAgB;EADb;EAUL;IAQE,cAAc;IACd,sBAAsB;EAFjB;EASP;IAEE,eAAe;IACf,YAAY;EAFR;EAYN;IAME,aAAa;IACb,8BAA8B;IAC9B,gCAAgC;IAChC,uBAAuB;IACvB,cAAc;IACd,gBAAgB;IAChB,6BAA6B;IAC7B,UAAU;EARW;EAevB;IACE,mBAAmB;EAD0B;EAQ/C;IACE,0BAA0B;EAD0B;EAQtD;IACE,sBAAsB;EADD;EAQvB;IACE,UAAU;EADE;EASd;IAEE;MACE,mBAAyD;MAAzD;QAAA,yDAAyD;MAAA;IAD7C;EADiC;EAUjD;IACE,gBAAgB;EADT;EAQT;IACE,wBAAwB;EADE;EAS5B;IACE,eAAe;IACf,mBAAmB;EAFS;EAS9B;IACE,oBAAoB;EADE;EAQxB;IACE,UAAU;EAD2B;EAIvC;IASE,gBAAgB;EADqB;EAQvC;IACE,gBAAgB;EADD;EAQjB;IAGE,kBAAkB;EADG;EAQvB;IAEE,YAAY;EADc;EAQ5B;IACE,wBAAwB;EADmB;AA3YnC;AAgZZ;EACE;IAAA,mBAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,eAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,UAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;IAAnB;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,sCAAmB;EAAA;EAAnB;IAAA,cAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,aAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,WAAmB;IAAnB,YAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,gCAAmB;EAAA;EAAnB;IAAA,WAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,0CAAmB;IAAnB,sDAAmB;EAAA;EAAnB;IAAA,sBAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,8BAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,SAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,gBAAmB;EAAA;EAAnB;IAAA,iCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,qBAAmB;EAAA;EAAnB;IAAA,uBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,yCAAmB;IAAnB,uBAAmB;EAAA;EAAnB;IAAA,oCAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,2DAAmB;IAAnB;MAAA,0EAAmB;IAAA;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,oBAAmB;EAAA;EAAnB;IAAA,uCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,qCAAmB;EAAA;EAAnB;IAAA,iBAAmB;EAAA;EAAnB;IAAA,wCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,yCAAmB;EAAA;EAAnB;IAAA,kBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,6DAAmB;EAAA;EAAnB;IAAA,2BAAmB;IAAnB,kCAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,yBAAmB;IAAnB,2DAAmB;EAAA;EAAnB;IAAA,2CAAmB;IAAnB,sCAAmB;EAAA;EAAnB;IAAA,6CAAmB;IAAnB,wCAAmB;EAAA;EAAnB;IAAA,mBAAmB;EAAA;EAAnB;IAAA,6BAAmB;EAAA;EAAnB;IAAA,yBAAmB;EAAA;EAAnB;IAAA,+BAAmB;EAAA;EAAnB;IAAA,wCAAmB;IAAnB,wRAAmB;IAAnB,gRAAmB;EAAA;EAAnB;IAAA,uKAAmB;IAAnB,qFAAmB;IAAnB,2EAAmB;EAAA;EAAnB;IAAA,oBAAmB;IAAnB,0BAAmB;EAAA;EAAnB;IAAA;MAAA;QAAA,6BAAmB;MAAA;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,mCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,SAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,oBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,kBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,wCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,kCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,uCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,gBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,sBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,8BAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,6CAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,UAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,iCAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,qBAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,0BAAmB;MAAnB,4DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,2DAAmB;IAAA;EAAA;EAAnB;IAAA;MAAA,yBAAmB;MAAnB,kCAAmB;IAAA;EAAA;AADJ;ACn3BjB;EACE;IACS,kBAAQ;IAAC,iBAAY;IAAC,6BAAc;EAC5C;EACD;IACS,kBAAQ;IAAC,+BAAO;IAAC,qBAAI;IAAC,wCAAY;IAAC,gBAAY;IAAZ,0BAAY;EACvD;EACD;IACS,kBAAQ;IAAC,+BAAO;IAAC,qBAAI;IAAC,oCAAQ;IAAC,+BAAO;IAAP,0LAAO;IAAC,gBAAY;IAAZ,0BAAY;IAAC;MAAA,+BAAU;MAAV,0LAAU;IAAA;EACtE;EAED;;;;IAIS,6BAAc;EACtB;EACD;IACS,sCAAK;IAAC,0BAAa;IAAb,gCAAa;IAAC,6CAAa;IAAb,wCAAa;IAAC;MAAA,0BAAgB;MAAhB,gCAAgB;IAAA;EAC1D;EACD;IACS,yBAAO;IAAP,2DAAO;IAAC,2CAAW;IAAX,sCAAW;IAAC;MAAA,0BAAW;MAAX,4DAAW;IAAA;EACvC;EACD;IACS,uCAAI;IAAC,oCAAI;IAAC,qBAAoB;IAAC,yCAAU;IAAV,sBAAU;IAAC,uCAAI;IAAC,sCAAI;IAAC,yBAAO;IAAP,2DAAO;IAAC,yBAAU;IAAC;MAAA,0BAAW;MAAX,4DAAW;IAAA;EAC1F;EAED;IACS,aAAI;IAAC,sBAAQ;IAAC,mBAAY;EAClC;EACD;IACS,YAAQ;IAAC;MAAA,YAAW;IAAA;EAC5B;EAED;IACS,kBAAW;IAAC,yBAAO;IAAP,2DAAO;IAAC,6BAAc;IAAC;MAAA,2BAAY;MAAZ,6DAAY;IAAA;EACvD;EAED;IACS,uCAAI;IAAC,sCAAI;IAAC,aAAI;IAAC,0DAA+C;IAAC,iCAAO;IAAC,yBAAO;IAAP,2DAAO;IAAC,kBAAU;IAAC;MAAA,uCAAO;IAAA;EACzG;EAED;IACS,aAAI;IAAC,mBAAY;IAAC,6BAAK;EAC/B;EACD;IACS,WAAQ;EAChB;AACF;AAED;EACE;IACS,kBAAQ;IAAC,kBAAc;IAAC,gCAAQ;IAAC,mBAAK;IAAC,2CAAgB;IAAhB,0BAAgB;IAAC,6EAAmB;IAAnB;MAAA,0EAAmB;IAAA;IAAC,gBAAY;IAAZ,0BAAY;IAAC;MAAA,kBAAiB;IAAA;EAClH;EACD;IACS,kBAAQ;IAAC,kBAAc;IAAC,gCAAQ;IAAC,WAAO;IAAC,wCAAY;IAAC,gBAAY;IAAZ,0BAAY;IAAC;MAAA,kBAAiB;IAAA;IAC3F,6BAA8B;IAC9B,0BAA2B;IAC3B,sCAAuC;EACxC;EAED;IACE,2CAA4C;IAC5C,8CAA+C;EAChD;EAED;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,kBAAW;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAAC,6BAAW;IAAX,8CAAW;IAAC;MAAA,wHAAoB;MAApB,sIAAoB;IAAA;IAAC;MAAA,gFAA+B;MAA/B;QAAA,6EAA+B;MAAA;IAAA;IAAC;MAAA,2BAA2B;MAA3B,4GAA2B;IAAA;IAAC;MAAA,0CAA+B;IAAA;IAAC;MAAA,wBAA0B;MAA1B,mBAA0B;IAAA;IAC5Q,iBAAkB;EACnB;EAED;IACS,oCAAgB;IAAC,wCAAY;IAAC,yBAAU;IAAC;MAAA;QAAA,6CAAsB;QAAtB,sDAAsB;MAAA;IAAA;IAAC;MAAA;QAAA,oCAAsB;MAAA;IAAA;IAAC;MAAA;QAAA,wCAAkB;MAAA;IAAA;IAChH,gBAAiB;EAClB;EAED;IACS,oCAAgB;IAAC,2DAAW;IAAX;MAAA,0EAAW;IAAA;IAAC,6BAAc;IAAC;MAAA;QAAA,6CAAsB;QAAtB,sDAAsB;MAAA;IAAA;IAAC;MAAA;QAAA,2DAAiB;QAAjB;UAAA,0EAAiB;QAAA;MAAA;IAAA;IAC3F,2BAA4B;IAC5B,gBAAiB;EAClB;EAED;IACS,qBAAY;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,oCAAgB;IAAC,2DAAW;IAAX;MAAA,0EAAW;IAAA;IAAC,yBAAO;IAAP,2DAAO;IAAC,6BAAc;IAAC;MAAA,2BAAY;MAAZ,6DAAY;IAAA;IACtG,iBAAkB;IAClB,2BAA4B;IAC5B;sCAEmC;EACpC;EAED;IACS,kBAAQ;EAChB;EACD;IACS,kBAAQ;IAAC,iBAAa;IAAC,mBAAK;IAAC,wCAAe;IAAf,sBAAe;IAAC,yBAAa;IAAb,oBAAa;IAAC,oCAAgB;IAAC,gBAAY;IAAZ,0BAAY;EAChG;EAED;;;IAGS,oBAAS;IAAC;MAAA,qBAAa;IAAA;EAC/B;EAED;IACS,aAAI;IAAC,WAAM;IAAC,gBAAa;IAAC,uBAAW;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,uDAAe;IAAf;MAAA,sEAAe;IAAA;IAAC,wCAAY;IAAC,yBAAU;IACtG,8CAA+C;EAChD;EACD;IACS,uCAAI;IAAC,aAAI;IAAC,qBAAoB;IAAC,kCAAQ;IAAC;MAAA,uCAAO;IAAA;EACvD;EACD;IACS,wCAAY;IAAZ,yCAAY;EACpB;EAED;IACS,qBAAS;IAAC,uCAAI;IAAC,uCAAI;IAAC,uCAAK;IAAC,yBAAO;IAAP,2DAAO;IAAC;MAAA,2BAAY;MAAZ,6DAAY;IAAA;EACtD;EAED;IACS,uCAAI;IAAC,aAAI;IAAC,6BAAK;IAAC,wCAAQ;IAAR,qBAAQ;IAAC,uDAAe;IAAf;MAAA,sEAAe;IAAA;IAAC,qCAAI;IAAC,wCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC;MAAA,uCAAO;IAAA;IAAC;MAAA,gDAAc;IAAA;IAAC;MAAA,6BAAQ;IAAA;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;EAC/G;EAED;IACS,oBAAW;IAAC,mBAAY;IAAC,uBAAc;IAAC,6BAAK;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,wCAAI;IAAC,uCAAI;IAAC,kBAAW;IAAC,2CAAW;IAAX,sCAAW;IAAC,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAAC,6BAAW;IAAX,8CAAW;IAAC;MAAA,wHAAoB;MAApB,sIAAoB;IAAA;IAAC;MAAA,0DAA2B;MAA3B;QAAA,yEAA2B;MAAA;IAAA;IAAC;MAAA,2BAA2B;MAA3B,4GAA2B;IAAA;IAAC;MAAA,8CAAmC;IAAA;IAAC;MAAA,wBAA0B;MAA1B,mBAA0B;IAAA;EAC7R;EAED;IACS,gCAAY;IAAC,oCAAQ;IAAC,6BAAc;IAAC;MAAA;QAAA,6CAAsB;QAAtB,sDAAsB;MAAA;IAAA;IAAC;MAAA;QAAA,wCAAkB;MAAA;IAAA;EACtF;EAED;IACS,uDAAe;IAAf;MAAA,sEAAe;IAAA;IAAC,2DAAW;IAAX;MAAA,0EAAW;IAAA;IAAC,yBAAU;IAAC;MAAA;QAAA,6CAAsB;QAAtB,sDAAsB;MAAA;IAAA;IAAC;MAAA;QAAA,uDAAqB;QAArB;UAAA,sEAAqB;QAAA;MAAA;IAAA;IAAC;MAAA;QAAA,2DAAiB;QAAjB;UAAA,0EAAiB;QAAA;MAAA;IAAA;IAC5G,2BAA4B;EAC7B;EAED;IACS,qBAAY;IAAC,WAAQ;IAAC;MAAA,WAAW;IAAA;IACxC,oCAAqC;EACtC;EAED;IACS,yBAAO;IAAP,2DAAO;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;EAC1B;EAED;IACE,+BAAgC;IACzB,qBAAY;IAAC,WAAQ;EAC7B;EAED;IACE,+BAAgC;IACzB,qBAAY;IAAC,WAAQ;IAAC;MAAA,WAAW;IAAA;EACzC;EAED;;IAES,YAAS;IAAC,2CAAc;IAAd,wBAAc;IAAC,oCAAgB;IAAC,wCAAI;IAAC,mBAAiB;EACxE;EAED;IACS,gCAAG;IAAC,YAAS;IAAC,wCAAa;IAAC,wCAAc;IAAd,qBAAc;IAAC,yCAAc;IAAd,sBAAc;IAAC,oCAAgB;IAAC,uCAAI;IAAC,sCAAI;IAAC,mBAAiB;IAAC;MAAA,sCAAO;IAAA;EACtH;EAED;IACS,aAAI;IAAC,eAAS;IAAC,oCAAO;IAAC,iCAAO;IAAC,wCAAI;IAAC,wCAAI;IAAC,2BAAS;IAAT,6DAAS;IAAC;MAAA,oCAAU;IAAA;IAAC;MAAA,iCAAU;IAAA;IAAC;MAAA,wCAAO;IAAA;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;EACnG;EAED;IACS,aAAI;IAAC,mBAAY;IAAC,uBAAc;IAAC,QAAS;EAClD;EAED;IACS,uCAAI;IAAC,wCAAK;IAAC,kBAAW;IAAC,2BAAS;IAAT,6DAAS;IAAC,6BAAc;IAAC;MAAA,uCAAO;IAAA;IAAC;MAAA,yBAAU;MAAV,2DAAU;IAAA;EAC1E;EAED;IACS,uCAAI;IAAC,aAAI;IAAC,qBAAoB;IAAC,kCAAQ;IAAC;MAAA,uCAAO;IAAA;EACvD;EAED;IACS,WAAM;IAAC,gBAAa;IAAC,+BAAU;IAAC,oCAAM;IAAN,iBAAM;IAAC,uDAAe;IAAf;MAAA,sEAAe;IAAA;IAAC,wCAAY;IAAC,yBAAU;IAAC,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAAC,6BAAW;IAAX,8CAAW;IAAC;MAAA;QAAA,2CAAoB;QAApB,sDAAoB;MAAA;IAAA;IAAC;MAAA;QAAA,wCAAkB;MAAA;IAAA;IACrK,8CAA+C;EAChD;EAED;IACS,cAAK;IAAC,+BAAU;IAAC,iCAAG;IAAC;MAAA,iCAAM;IAAA;EACnC;EAED;IACS,+BAAU;IAAC,wHAAM;IAAN,sIAAM;IAAC,mCAAU;IAAC,2BAAa;IAAb,4GAAa;IAAC,8CAAqB;IAAC,wBAAY;IAAZ,mBAAY;EACrF;EAED;IACS,0BAAa;IAAb,gCAAa;IAAC,6CAAa;IAAb,wCAAa;IAAC,yBAAU;IAAC,wBAAc;IAAd,qFAAc;IAAd,2EAAc;IAAC,oBAAY;IAAZ,0BAAY;IAAC;MAAA,0BAAgB;MAAhB,gCAAgB;IAAA;EAC3F;EAED;IACS,+BAAS;IAAC,0BAAkB;EACpC;EAED;IACS,oCAAI;IAAC,aAAI;IAAC,eAAS;IAAC,mBAAY;IAAC,oCAAO;IAAC,iCAAO;IAAC,yBAAO;IAAP,2DAAO;IAAC,6BAAc;IAAC;MAAA,2BAAY;MAAZ,6DAAY;IAAA;EAC5F;EAED;IACS,6BAAc;EACtB;EAED;IACS,oCAAI;IAAC,2BAAiB;IAAjB,mCAAiB;IAAC,4BAAa;IAAC;MAAA,yBAAkB;MAAlB,mCAAkB;IAAA;EAC/D;EAED;IACE,kBAAmB;EACpB;EAED;IACE,gBAAiB;EAClB;EAED;IACE,aAAc;IACd,8BAA+B;EAChC;EAED;IACE,cAAe;IACf,YAAa;IACb,iBAAkB;EACnB;EAED;IACE,kBAAmB;IACnB,QAAS;IACT,OAAQ;IACR,2BAA4B;EAC7B;EAED;IACE,kBAAmB;IACnB,QAAS;IACT,QAAS;IACT,2BAA4B;EAC7B;AACF;AAED;EACE;IACE,oBAAqB;EACtB;AACF;ADynBC;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,gBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;EAAnB,oBAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AAAnB;EAAA,WAAmB;EAAnB,eAAmB;AAAA;AC/2ByB;EAAA,WAAY;EAAZ,eAAY;EAAZ,iBAAY;AAAA;AAGhB;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AAAP;EAAA,sBAAO;EAAP,eAAO;EAAP,mBAAO;AAAA;AAAP;EAAA,WAAO;EAAP,eAAO;AAAA;AA2DwE;EAAA,WAAW;EAAX,eAAW;AAAA;AAAC;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,sBAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;AAAA;AAApB;EAAA,kBAAoB;EAApB,eAAoB;EAApB,kBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,mBAAoB;AAAA;AAApB;EAAA,WAAoB;EAApB,eAAoB;EAApB,wBAAoB;AAAA;ADizBvJ;EAAA;IAAA;MAAA,mBAAmB;MAAnB,mBAAmB;MAAnB,mBAAmB;MAAnB,wBAAmB;MAAnB,yBAAmB;MAAnB,2BAAmB;MAAnB,iCAAmB;MAAnB,+BAAmB;MAAnB,gCAAmB;MAAnB,iCAAmB;MAAnB,6BAAmB;MAAnB,8BAAmB;MAAnB,+BAAmB;MAAnB,4BAAmB;MAAnB,sBAAmB;MC/2ByB,gBAAY;MAGhB,kBAAO;MAAP,wBAAO;MAAP,sBAAO;MAAP,uBAAO;MAAP,wBAAO;MAAP,oBAAO;MAAP,qBAAO;MAAP,sBAAO;MAAP,mBAAO;MAAP,yBAAO;MAAP,+BAAO;MAAP,4BAAO;MAAP,8BAAO;MA2DwE,kBAAW;MAAC,sBAAoB;MAApB,0BAAoB;MAApB,uBAAoB;MAApB,4BAAoB;MAApB,gCAAoB;MAApB,6BAAoB;MAApB,wBAAoB;MAApB,2BAAoB;MAApB,8BAAoB;MAApB,iCAAoB;MAApB,wBAAoB;MAApB,2BAAoB;MAApB,4BAAoB;MAApB,kCAAoB;IDizBpI;EAAA;AAAA","sourcesContent":[null,"@layer theme, base, components, utilities;\n\n@layer theme {\n  @theme default {\n    --font-sans:\n      ui-sans-serif, system-ui, sans-serif, \"Apple Color Emoji\",\n      \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    --font-serif: ui-serif, Georgia, Cambria, \"Times New Roman\", Times, serif;\n    --font-mono:\n      ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\",\n      \"Courier New\", monospace;\n\n    --color-red-50: oklch(97.1% 0.013 17.38);\n    --color-red-100: oklch(93.6% 0.032 17.717);\n    --color-red-200: oklch(88.5% 0.062 18.334);\n    --color-red-300: oklch(80.8% 0.114 19.571);\n    --color-red-400: oklch(70.4% 0.191 22.216);\n    --color-red-500: oklch(63.7% 0.237 25.331);\n    --color-red-600: oklch(57.7% 0.245 27.325);\n    --color-red-700: oklch(50.5% 0.213 27.518);\n    --color-red-800: oklch(44.4% 0.177 26.899);\n    --color-red-900: oklch(39.6% 0.141 25.723);\n    --color-red-950: oklch(25.8% 0.092 26.042);\n\n    --color-orange-50: oklch(98% 0.016 73.684);\n    --color-orange-100: oklch(95.4% 0.038 75.164);\n    --color-orange-200: oklch(90.1% 0.076 70.697);\n    --color-orange-300: oklch(83.7% 0.128 66.29);\n    --color-orange-400: oklch(75% 0.183 55.934);\n    --color-orange-500: oklch(70.5% 0.213 47.604);\n    --color-orange-600: oklch(64.6% 0.222 41.116);\n    --color-orange-700: oklch(55.3% 0.195 38.402);\n    --color-orange-800: oklch(47% 0.157 37.304);\n    --color-orange-900: oklch(40.8% 0.123 38.172);\n    --color-orange-950: oklch(26.6% 0.079 36.259);\n\n    --color-amber-50: oklch(98.7% 0.022 95.277);\n    --color-amber-100: oklch(96.2% 0.059 95.617);\n    --color-amber-200: oklch(92.4% 0.12 95.746);\n    --color-amber-300: oklch(87.9% 0.169 91.605);\n    --color-amber-400: oklch(82.8% 0.189 84.429);\n    --color-amber-500: oklch(76.9% 0.188 70.08);\n    --color-amber-600: oklch(66.6% 0.179 58.318);\n    --color-amber-700: oklch(55.5% 0.163 48.998);\n    --color-amber-800: oklch(47.3% 0.137 46.201);\n    --color-amber-900: oklch(41.4% 0.112 45.904);\n    --color-amber-950: oklch(27.9% 0.077 45.635);\n\n    --color-yellow-50: oklch(98.7% 0.026 102.212);\n    --color-yellow-100: oklch(97.3% 0.071 103.193);\n    --color-yellow-200: oklch(94.5% 0.129 101.54);\n    --color-yellow-300: oklch(90.5% 0.182 98.111);\n    --color-yellow-400: oklch(85.2% 0.199 91.936);\n    --color-yellow-500: oklch(79.5% 0.184 86.047);\n    --color-yellow-600: oklch(68.1% 0.162 75.834);\n    --color-yellow-700: oklch(55.4% 0.135 66.442);\n    --color-yellow-800: oklch(47.6% 0.114 61.907);\n    --color-yellow-900: oklch(42.1% 0.095 57.708);\n    --color-yellow-950: oklch(28.6% 0.066 53.813);\n\n    --color-lime-50: oklch(98.6% 0.031 120.757);\n    --color-lime-100: oklch(96.7% 0.067 122.328);\n    --color-lime-200: oklch(93.8% 0.127 124.321);\n    --color-lime-300: oklch(89.7% 0.196 126.665);\n    --color-lime-400: oklch(84.1% 0.238 128.85);\n    --color-lime-500: oklch(76.8% 0.233 130.85);\n    --color-lime-600: oklch(64.8% 0.2 131.684);\n    --color-lime-700: oklch(53.2% 0.157 131.589);\n    --color-lime-800: oklch(45.3% 0.124 130.933);\n    --color-lime-900: oklch(40.5% 0.101 131.063);\n    --color-lime-950: oklch(27.4% 0.072 132.109);\n\n    --color-green-50: oklch(98.2% 0.018 155.826);\n    --color-green-100: oklch(96.2% 0.044 156.743);\n    --color-green-200: oklch(92.5% 0.084 155.995);\n    --color-green-300: oklch(87.1% 0.15 154.449);\n    --color-green-400: oklch(79.2% 0.209 151.711);\n    --color-green-500: oklch(72.3% 0.219 149.579);\n    --color-green-600: oklch(62.7% 0.194 149.214);\n    --color-green-700: oklch(52.7% 0.154 150.069);\n    --color-green-800: oklch(44.8% 0.119 151.328);\n    --color-green-900: oklch(39.3% 0.095 152.535);\n    --color-green-950: oklch(26.6% 0.065 152.934);\n\n    --color-emerald-50: oklch(97.9% 0.021 166.113);\n    --color-emerald-100: oklch(95% 0.052 163.051);\n    --color-emerald-200: oklch(90.5% 0.093 164.15);\n    --color-emerald-300: oklch(84.5% 0.143 164.978);\n    --color-emerald-400: oklch(76.5% 0.177 163.223);\n    --color-emerald-500: oklch(69.6% 0.17 162.48);\n    --color-emerald-600: oklch(59.6% 0.145 163.225);\n    --color-emerald-700: oklch(50.8% 0.118 165.612);\n    --color-emerald-800: oklch(43.2% 0.095 166.913);\n    --color-emerald-900: oklch(37.8% 0.077 168.94);\n    --color-emerald-950: oklch(26.2% 0.051 172.552);\n\n    --color-teal-50: oklch(98.4% 0.014 180.72);\n    --color-teal-100: oklch(95.3% 0.051 180.801);\n    --color-teal-200: oklch(91% 0.096 180.426);\n    --color-teal-300: oklch(85.5% 0.138 181.071);\n    --color-teal-400: oklch(77.7% 0.152 181.912);\n    --color-teal-500: oklch(70.4% 0.14 182.503);\n    --color-teal-600: oklch(60% 0.118 184.704);\n    --color-teal-700: oklch(51.1% 0.096 186.391);\n    --color-teal-800: oklch(43.7% 0.078 188.216);\n    --color-teal-900: oklch(38.6% 0.063 188.416);\n    --color-teal-950: oklch(27.7% 0.046 192.524);\n\n    --color-cyan-50: oklch(98.4% 0.019 200.873);\n    --color-cyan-100: oklch(95.6% 0.045 203.388);\n    --color-cyan-200: oklch(91.7% 0.08 205.041);\n    --color-cyan-300: oklch(86.5% 0.127 207.078);\n    --color-cyan-400: oklch(78.9% 0.154 211.53);\n    --color-cyan-500: oklch(71.5% 0.143 215.221);\n    --color-cyan-600: oklch(60.9% 0.126 221.723);\n    --color-cyan-700: oklch(52% 0.105 223.128);\n    --color-cyan-800: oklch(45% 0.085 224.283);\n    --color-cyan-900: oklch(39.8% 0.07 227.392);\n    --color-cyan-950: oklch(30.2% 0.056 229.695);\n\n    --color-sky-50: oklch(97.7% 0.013 236.62);\n    --color-sky-100: oklch(95.1% 0.026 236.824);\n    --color-sky-200: oklch(90.1% 0.058 230.902);\n    --color-sky-300: oklch(82.8% 0.111 230.318);\n    --color-sky-400: oklch(74.6% 0.16 232.661);\n    --color-sky-500: oklch(68.5% 0.169 237.323);\n    --color-sky-600: oklch(58.8% 0.158 241.966);\n    --color-sky-700: oklch(50% 0.134 242.749);\n    --color-sky-800: oklch(44.3% 0.11 240.79);\n    --color-sky-900: oklch(39.1% 0.09 240.876);\n    --color-sky-950: oklch(29.3% 0.066 243.157);\n\n    --color-blue-50: oklch(97% 0.014 254.604);\n    --color-blue-100: oklch(93.2% 0.032 255.585);\n    --color-blue-200: oklch(88.2% 0.059 254.128);\n    --color-blue-300: oklch(80.9% 0.105 251.813);\n    --color-blue-400: oklch(70.7% 0.165 254.624);\n    --color-blue-500: oklch(62.3% 0.214 259.815);\n    --color-blue-600: oklch(54.6% 0.245 262.881);\n    --color-blue-700: oklch(48.8% 0.243 264.376);\n    --color-blue-800: oklch(42.4% 0.199 265.638);\n    --color-blue-900: oklch(37.9% 0.146 265.522);\n    --color-blue-950: oklch(28.2% 0.091 267.935);\n\n    --color-indigo-50: oklch(96.2% 0.018 272.314);\n    --color-indigo-100: oklch(93% 0.034 272.788);\n    --color-indigo-200: oklch(87% 0.065 274.039);\n    --color-indigo-300: oklch(78.5% 0.115 274.713);\n    --color-indigo-400: oklch(67.3% 0.182 276.935);\n    --color-indigo-500: oklch(58.5% 0.233 277.117);\n    --color-indigo-600: oklch(51.1% 0.262 276.966);\n    --color-indigo-700: oklch(45.7% 0.24 277.023);\n    --color-indigo-800: oklch(39.8% 0.195 277.366);\n    --color-indigo-900: oklch(35.9% 0.144 278.697);\n    --color-indigo-950: oklch(25.7% 0.09 281.288);\n\n    --color-violet-50: oklch(96.9% 0.016 293.756);\n    --color-violet-100: oklch(94.3% 0.029 294.588);\n    --color-violet-200: oklch(89.4% 0.057 293.283);\n    --color-violet-300: oklch(81.1% 0.111 293.571);\n    --color-violet-400: oklch(70.2% 0.183 293.541);\n    --color-violet-500: oklch(60.6% 0.25 292.717);\n    --color-violet-600: oklch(54.1% 0.281 293.009);\n    --color-violet-700: oklch(49.1% 0.27 292.581);\n    --color-violet-800: oklch(43.2% 0.232 292.759);\n    --color-violet-900: oklch(38% 0.189 293.745);\n    --color-violet-950: oklch(28.3% 0.141 291.089);\n\n    --color-purple-50: oklch(97.7% 0.014 308.299);\n    --color-purple-100: oklch(94.6% 0.033 307.174);\n    --color-purple-200: oklch(90.2% 0.063 306.703);\n    --color-purple-300: oklch(82.7% 0.119 306.383);\n    --color-purple-400: oklch(71.4% 0.203 305.504);\n    --color-purple-500: oklch(62.7% 0.265 303.9);\n    --color-purple-600: oklch(55.8% 0.288 302.321);\n    --color-purple-700: oklch(49.6% 0.265 301.924);\n    --color-purple-800: oklch(43.8% 0.218 303.724);\n    --color-purple-900: oklch(38.1% 0.176 304.987);\n    --color-purple-950: oklch(29.1% 0.149 302.717);\n\n    --color-fuchsia-50: oklch(97.7% 0.017 320.058);\n    --color-fuchsia-100: oklch(95.2% 0.037 318.852);\n    --color-fuchsia-200: oklch(90.3% 0.076 319.62);\n    --color-fuchsia-300: oklch(83.3% 0.145 321.434);\n    --color-fuchsia-400: oklch(74% 0.238 322.16);\n    --color-fuchsia-500: oklch(66.7% 0.295 322.15);\n    --color-fuchsia-600: oklch(59.1% 0.293 322.896);\n    --color-fuchsia-700: oklch(51.8% 0.253 323.949);\n    --color-fuchsia-800: oklch(45.2% 0.211 324.591);\n    --color-fuchsia-900: oklch(40.1% 0.17 325.612);\n    --color-fuchsia-950: oklch(29.3% 0.136 325.661);\n\n    --color-pink-50: oklch(97.1% 0.014 343.198);\n    --color-pink-100: oklch(94.8% 0.028 342.258);\n    --color-pink-200: oklch(89.9% 0.061 343.231);\n    --color-pink-300: oklch(82.3% 0.12 346.018);\n    --color-pink-400: oklch(71.8% 0.202 349.761);\n    --color-pink-500: oklch(65.6% 0.241 354.308);\n    --color-pink-600: oklch(59.2% 0.249 0.584);\n    --color-pink-700: oklch(52.5% 0.223 3.958);\n    --color-pink-800: oklch(45.9% 0.187 3.815);\n    --color-pink-900: oklch(40.8% 0.153 2.432);\n    --color-pink-950: oklch(28.4% 0.109 3.907);\n\n    --color-rose-50: oklch(96.9% 0.015 12.422);\n    --color-rose-100: oklch(94.1% 0.03 12.58);\n    --color-rose-200: oklch(89.2% 0.058 10.001);\n    --color-rose-300: oklch(81% 0.117 11.638);\n    --color-rose-400: oklch(71.2% 0.194 13.428);\n    --color-rose-500: oklch(64.5% 0.246 16.439);\n    --color-rose-600: oklch(58.6% 0.253 17.585);\n    --color-rose-700: oklch(51.4% 0.222 16.935);\n    --color-rose-800: oklch(45.5% 0.188 13.697);\n    --color-rose-900: oklch(41% 0.159 10.272);\n    --color-rose-950: oklch(27.1% 0.105 12.094);\n\n    --color-slate-50: oklch(98.4% 0.003 247.858);\n    --color-slate-100: oklch(96.8% 0.007 247.896);\n    --color-slate-200: oklch(92.9% 0.013 255.508);\n    --color-slate-300: oklch(86.9% 0.022 252.894);\n    --color-slate-400: oklch(70.4% 0.04 256.788);\n    --color-slate-500: oklch(55.4% 0.046 257.417);\n    --color-slate-600: oklch(44.6% 0.043 257.281);\n    --color-slate-700: oklch(37.2% 0.044 257.287);\n    --color-slate-800: oklch(27.9% 0.041 260.031);\n    --color-slate-900: oklch(20.8% 0.042 265.755);\n    --color-slate-950: oklch(12.9% 0.042 264.695);\n\n    --color-gray-50: oklch(98.5% 0.002 247.839);\n    --color-gray-100: oklch(96.7% 0.003 264.542);\n    --color-gray-200: oklch(92.8% 0.006 264.531);\n    --color-gray-300: oklch(87.2% 0.01 258.338);\n    --color-gray-400: oklch(70.7% 0.022 261.325);\n    --color-gray-500: oklch(55.1% 0.027 264.364);\n    --color-gray-600: oklch(44.6% 0.03 256.802);\n    --color-gray-700: oklch(37.3% 0.034 259.733);\n    --color-gray-800: oklch(27.8% 0.033 256.848);\n    --color-gray-900: oklch(21% 0.034 264.665);\n    --color-gray-950: oklch(13% 0.028 261.692);\n\n    --color-zinc-50: oklch(98.5% 0 0);\n    --color-zinc-100: oklch(96.7% 0.001 286.375);\n    --color-zinc-200: oklch(92% 0.004 286.32);\n    --color-zinc-300: oklch(87.1% 0.006 286.286);\n    --color-zinc-400: oklch(70.5% 0.015 286.067);\n    --color-zinc-500: oklch(55.2% 0.016 285.938);\n    --color-zinc-600: oklch(44.2% 0.017 285.786);\n    --color-zinc-700: oklch(37% 0.013 285.805);\n    --color-zinc-800: oklch(27.4% 0.006 286.033);\n    --color-zinc-900: oklch(21% 0.006 285.885);\n    --color-zinc-950: oklch(14.1% 0.005 285.823);\n\n    --color-neutral-50: oklch(98.5% 0 0);\n    --color-neutral-100: oklch(97% 0 0);\n    --color-neutral-200: oklch(92.2% 0 0);\n    --color-neutral-300: oklch(87% 0 0);\n    --color-neutral-400: oklch(70.8% 0 0);\n    --color-neutral-500: oklch(55.6% 0 0);\n    --color-neutral-600: oklch(43.9% 0 0);\n    --color-neutral-700: oklch(37.1% 0 0);\n    --color-neutral-800: oklch(26.9% 0 0);\n    --color-neutral-900: oklch(20.5% 0 0);\n    --color-neutral-950: oklch(14.5% 0 0);\n\n    --color-stone-50: oklch(98.5% 0.001 106.423);\n    --color-stone-100: oklch(97% 0.001 106.424);\n    --color-stone-200: oklch(92.3% 0.003 48.717);\n    --color-stone-300: oklch(86.9% 0.005 56.366);\n    --color-stone-400: oklch(70.9% 0.01 56.259);\n    --color-stone-500: oklch(55.3% 0.013 58.071);\n    --color-stone-600: oklch(44.4% 0.011 73.639);\n    --color-stone-700: oklch(37.4% 0.01 67.558);\n    --color-stone-800: oklch(26.8% 0.007 34.298);\n    --color-stone-900: oklch(21.6% 0.006 56.043);\n    --color-stone-950: oklch(14.7% 0.004 49.25);\n\n    --color-black: #000;\n    --color-white: #fff;\n\n    --spacing: 0.25rem;\n\n    --breakpoint-sm: 40rem;\n    --breakpoint-md: 48rem;\n    --breakpoint-lg: 64rem;\n    --breakpoint-xl: 80rem;\n    --breakpoint-2xl: 96rem;\n\n    --container-3xs: 16rem;\n    --container-2xs: 18rem;\n    --container-xs: 20rem;\n    --container-sm: 24rem;\n    --container-md: 28rem;\n    --container-lg: 32rem;\n    --container-xl: 36rem;\n    --container-2xl: 42rem;\n    --container-3xl: 48rem;\n    --container-4xl: 56rem;\n    --container-5xl: 64rem;\n    --container-6xl: 72rem;\n    --container-7xl: 80rem;\n\n    --text-xs: 0.75rem;\n    --text-xs--line-height: calc(1 / 0.75);\n    --text-sm: 0.875rem;\n    --text-sm--line-height: calc(1.25 / 0.875);\n    --text-base: 1rem;\n    --text-base--line-height: calc(1.5 / 1);\n    --text-lg: 1.125rem;\n    --text-lg--line-height: calc(1.75 / 1.125);\n    --text-xl: 1.25rem;\n    --text-xl--line-height: calc(1.75 / 1.25);\n    --text-2xl: 1.5rem;\n    --text-2xl--line-height: calc(2 / 1.5);\n    --text-3xl: 1.875rem;\n    --text-3xl--line-height: calc(2.25 / 1.875);\n    --text-4xl: 2.25rem;\n    --text-4xl--line-height: calc(2.5 / 2.25);\n    --text-5xl: 3rem;\n    --text-5xl--line-height: 1;\n    --text-6xl: 3.75rem;\n    --text-6xl--line-height: 1;\n    --text-7xl: 4.5rem;\n    --text-7xl--line-height: 1;\n    --text-8xl: 6rem;\n    --text-8xl--line-height: 1;\n    --text-9xl: 8rem;\n    --text-9xl--line-height: 1;\n\n    --font-weight-thin: 100;\n    --font-weight-extralight: 200;\n    --font-weight-light: 300;\n    --font-weight-normal: 400;\n    --font-weight-medium: 500;\n    --font-weight-semibold: 600;\n    --font-weight-bold: 700;\n    --font-weight-extrabold: 800;\n    --font-weight-black: 900;\n\n    --tracking-tighter: -0.05em;\n    --tracking-tight: -0.025em;\n    --tracking-normal: 0em;\n    --tracking-wide: 0.025em;\n    --tracking-wider: 0.05em;\n    --tracking-widest: 0.1em;\n\n    --leading-tight: 1.25;\n    --leading-snug: 1.375;\n    --leading-normal: 1.5;\n    --leading-relaxed: 1.625;\n    --leading-loose: 2;\n\n    --radius-xs: 0.125rem;\n    --radius-sm: 0.25rem;\n    --radius-md: 0.375rem;\n    --radius-lg: 0.5rem;\n    --radius-xl: 0.75rem;\n    --radius-2xl: 1rem;\n    --radius-3xl: 1.5rem;\n    --radius-4xl: 2rem;\n\n    --shadow-2xs: 0 1px rgb(0 0 0 / 0.05);\n    --shadow-xs: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n    --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-md:\n      0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n    --shadow-lg:\n      0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n    --shadow-xl:\n      0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);\n    --shadow-2xl: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n\n    --inset-shadow-2xs: inset 0 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-xs: inset 0 1px 1px rgb(0 0 0 / 0.05);\n    --inset-shadow-sm: inset 0 2px 4px rgb(0 0 0 / 0.05);\n\n    --drop-shadow-xs: 0 1px 1px rgb(0 0 0 / 0.05);\n    --drop-shadow-sm: 0 1px 2px rgb(0 0 0 / 0.15);\n    --drop-shadow-md: 0 3px 3px rgb(0 0 0 / 0.12);\n    --drop-shadow-lg: 0 4px 4px rgb(0 0 0 / 0.15);\n    --drop-shadow-xl: 0 9px 7px rgb(0 0 0 / 0.1);\n    --drop-shadow-2xl: 0 25px 25px rgb(0 0 0 / 0.15);\n\n    --text-shadow-2xs: 0px 1px 0px rgb(0 0 0 / 0.15);\n    --text-shadow-xs: 0px 1px 1px rgb(0 0 0 / 0.2);\n    --text-shadow-sm:\n      0px 1px 0px rgb(0 0 0 / 0.075), 0px 1px 1px rgb(0 0 0 / 0.075),\n      0px 2px 2px rgb(0 0 0 / 0.075);\n    --text-shadow-md:\n      0px 1px 1px rgb(0 0 0 / 0.1), 0px 1px 2px rgb(0 0 0 / 0.1),\n      0px 2px 4px rgb(0 0 0 / 0.1);\n    --text-shadow-lg:\n      0px 1px 2px rgb(0 0 0 / 0.1), 0px 3px 2px rgb(0 0 0 / 0.1),\n      0px 4px 8px rgb(0 0 0 / 0.1);\n\n    --ease-in: cubic-bezier(0.4, 0, 1, 1);\n    --ease-out: cubic-bezier(0, 0, 0.2, 1);\n    --ease-in-out: cubic-bezier(0.4, 0, 0.2, 1);\n\n    --animate-spin: spin 1s linear infinite;\n    --animate-ping: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;\n    --animate-pulse: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n    --animate-bounce: bounce 1s infinite;\n\n    @keyframes spin {\n      to {\n        transform: rotate(360deg);\n      }\n    }\n\n    @keyframes ping {\n      75%,\n      100% {\n        transform: scale(2);\n        opacity: 0;\n      }\n    }\n\n    @keyframes pulse {\n      50% {\n        opacity: 0.5;\n      }\n    }\n\n    @keyframes bounce {\n      0%,\n      100% {\n        transform: translateY(-25%);\n        animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n      }\n\n      50% {\n        transform: none;\n        animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n      }\n    }\n\n    --blur-xs: 4px;\n    --blur-sm: 8px;\n    --blur-md: 12px;\n    --blur-lg: 16px;\n    --blur-xl: 24px;\n    --blur-2xl: 40px;\n    --blur-3xl: 64px;\n\n    --perspective-dramatic: 100px;\n    --perspective-near: 300px;\n    --perspective-normal: 500px;\n    --perspective-midrange: 800px;\n    --perspective-distant: 1200px;\n\n    --aspect-video: 16 / 9;\n\n    --default-transition-duration: 150ms;\n    --default-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n    --default-font-family: --theme(--font-sans, initial);\n    --default-font-feature-settings: --theme(\n      --font-sans--font-feature-settings,\n      initial\n    );\n    --default-font-variation-settings: --theme(\n      --font-sans--font-variation-settings,\n      initial\n    );\n    --default-mono-font-family: --theme(--font-mono, initial);\n    --default-mono-font-feature-settings: --theme(\n      --font-mono--font-feature-settings,\n      initial\n    );\n    --default-mono-font-variation-settings: --theme(\n      --font-mono--font-variation-settings,\n      initial\n    );\n  }\n\n  /* Deprecated */\n  @theme default inline reference {\n    --blur: 8px;\n    --shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);\n    --shadow-inner: inset 0 2px 4px 0 rgb(0 0 0 / 0.05);\n    --drop-shadow: 0 1px 2px rgb(0 0 0 / 0.1), 0 1px 1px rgb(0 0 0 / 0.06);\n    --radius: 0.25rem;\n    --max-width-prose: 65ch;\n  }\n}\n\n@layer base {\n  /*\n  1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n  2. Remove default margins and padding\n  3. Reset all borders.\n*/\n\n  *,\n  ::after,\n  ::before,\n  ::backdrop,\n  ::file-selector-button {\n    box-sizing: border-box; /* 1 */\n    margin: 0; /* 2 */\n    padding: 0; /* 2 */\n    border: 0 solid; /* 3 */\n  }\n\n  /*\n  1. Use a consistent sensible line-height in all browsers.\n  2. Prevent adjustments of font size after orientation changes in iOS.\n  3. Use a more readable tab size.\n  4. Use the user's configured `sans` font-family by default.\n  5. Use the user's configured `sans` font-feature-settings by default.\n  6. Use the user's configured `sans` font-variation-settings by default.\n  7. Disable tap highlights on iOS.\n*/\n\n  html,\n  :host {\n    line-height: 1.5; /* 1 */\n    -webkit-text-size-adjust: 100%; /* 2 */\n    tab-size: 4; /* 3 */\n    font-family: --theme(\n      --default-font-family,\n      ui-sans-serif,\n      system-ui,\n      sans-serif,\n      \"Apple Color Emoji\",\n      \"Segoe UI Emoji\",\n      \"Segoe UI Symbol\",\n      \"Noto Color Emoji\"\n    ); /* 4 */\n    font-feature-settings: --theme(\n      --default-font-feature-settings,\n      normal\n    ); /* 5 */\n    font-variation-settings: --theme(\n      --default-font-variation-settings,\n      normal\n    ); /* 6 */\n    -webkit-tap-highlight-color: transparent; /* 7 */\n  }\n\n  /*\n  1. Add the correct height in Firefox.\n  2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)\n  3. Reset the default border style to a 1px solid border.\n*/\n\n  hr {\n    height: 0; /* 1 */\n    color: inherit; /* 2 */\n    border-top-width: 1px; /* 3 */\n  }\n\n  /*\n  Add the correct text decoration in Chrome, Edge, and Safari.\n*/\n\n  abbr:where([title]) {\n    -webkit-text-decoration: underline dotted;\n    text-decoration: underline dotted;\n  }\n\n  /*\n  Remove the default font size and weight for headings.\n*/\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    font-size: inherit;\n    font-weight: inherit;\n  }\n\n  /*\n  Reset links to optimize for opt-in styling instead of opt-out.\n*/\n\n  a {\n    color: inherit;\n    -webkit-text-decoration: inherit;\n    text-decoration: inherit;\n  }\n\n  /*\n  Add the correct font weight in Edge and Safari.\n*/\n\n  b,\n  strong {\n    font-weight: bolder;\n  }\n\n  /*\n  1. Use the user's configured `mono` font-family by default.\n  2. Use the user's configured `mono` font-feature-settings by default.\n  3. Use the user's configured `mono` font-variation-settings by default.\n  4. Correct the odd `em` font sizing in all browsers.\n*/\n\n  code,\n  kbd,\n  samp,\n  pre {\n    font-family: --theme(\n      --default-mono-font-family,\n      ui-monospace,\n      SFMono-Regular,\n      Menlo,\n      Monaco,\n      Consolas,\n      \"Liberation Mono\",\n      \"Courier New\",\n      monospace\n    ); /* 1 */\n    font-feature-settings: --theme(\n      --default-mono-font-feature-settings,\n      normal\n    ); /* 2 */\n    font-variation-settings: --theme(\n      --default-mono-font-variation-settings,\n      normal\n    ); /* 3 */\n    font-size: 1em; /* 4 */\n  }\n\n  /*\n  Add the correct font size in all browsers.\n*/\n\n  small {\n    font-size: 80%;\n  }\n\n  /*\n  Prevent `sub` and `sup` elements from affecting the line height in all browsers.\n*/\n\n  sub,\n  sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  sub {\n    bottom: -0.25em;\n  }\n\n  sup {\n    top: -0.5em;\n  }\n\n  /*\n  1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)\n  2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)\n  3. Remove gaps between table borders by default.\n*/\n\n  table {\n    text-indent: 0; /* 1 */\n    border-color: inherit; /* 2 */\n    border-collapse: collapse; /* 3 */\n  }\n\n  /*\n  Use the modern Firefox focus style for all focusable elements.\n*/\n\n  :-moz-focusring {\n    outline: auto;\n  }\n\n  /*\n  Add the correct vertical alignment in Chrome and Firefox.\n*/\n\n  progress {\n    vertical-align: baseline;\n  }\n\n  /*\n  Add the correct display in Chrome and Safari.\n*/\n\n  summary {\n    display: list-item;\n  }\n\n  /*\n  Make lists unstyled by default.\n*/\n\n  ol,\n  ul,\n  menu {\n    list-style: none;\n  }\n\n  /*\n  1. Make replaced elements `display: block` by default. (https://github.com/mozdevs/cssremedy/issues/14)\n  2. Add `vertical-align: middle` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)\n      This can trigger a poorly considered lint error in some tools but is included by design.\n*/\n\n  img,\n  svg,\n  video,\n  canvas,\n  audio,\n  iframe,\n  embed,\n  object {\n    display: block; /* 1 */\n    vertical-align: middle; /* 2 */\n  }\n\n  /*\n  Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)\n*/\n\n  img,\n  video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  /*\n  1. Inherit font styles in all browsers.\n  2. Remove border radius in all browsers.\n  3. Remove background color in all browsers.\n  4. Ensure consistent opacity for disabled states in all browsers.\n*/\n\n  button,\n  input,\n  select,\n  optgroup,\n  textarea,\n  ::file-selector-button {\n    font: inherit; /* 1 */\n    font-feature-settings: inherit; /* 1 */\n    font-variation-settings: inherit; /* 1 */\n    letter-spacing: inherit; /* 1 */\n    color: inherit; /* 1 */\n    border-radius: 0; /* 2 */\n    background-color: transparent; /* 3 */\n    opacity: 1; /* 4 */\n  }\n\n  /*\n  Restore default font weight.\n*/\n\n  :where(select:is([multiple], [size])) optgroup {\n    font-weight: bolder;\n  }\n\n  /*\n  Restore indentation.\n*/\n\n  :where(select:is([multiple], [size])) optgroup option {\n    padding-inline-start: 20px;\n  }\n\n  /*\n  Restore space after button.\n*/\n\n  ::file-selector-button {\n    margin-inline-end: 4px;\n  }\n\n  /*\n  Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)\n*/\n\n  ::placeholder {\n    opacity: 1;\n  }\n\n  /*\n  Set the default placeholder color to a semi-transparent version of the current text color in browsers that do not\n  crash when using `color-mix(…)` with `currentcolor`. (https://github.com/tailwindlabs/tailwindcss/issues/17194)\n*/\n\n  @supports (not (-webkit-appearance: -apple-pay-button)) /* Not Safari */ or\n    (contain-intrinsic-size: 1px) /* Safari 17+ */ {\n    ::placeholder {\n      color: color-mix(in oklab, currentcolor 50%, transparent);\n    }\n  }\n\n  /*\n  Prevent resizing textareas horizontally by default.\n*/\n\n  textarea {\n    resize: vertical;\n  }\n\n  /*\n  Remove the inner padding in Chrome and Safari on macOS.\n*/\n\n  ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  /*\n  1. Ensure date/time inputs have the same height when empty in iOS Safari.\n  2. Ensure text alignment can be changed on date/time inputs in iOS Safari.\n*/\n\n  ::-webkit-date-and-time-value {\n    min-height: 1lh; /* 1 */\n    text-align: inherit; /* 2 */\n  }\n\n  /*\n  Prevent height from changing on date/time inputs in macOS Safari when the input is set to `display: block`.\n*/\n\n  ::-webkit-datetime-edit {\n    display: inline-flex;\n  }\n\n  /*\n  Remove excess padding from pseudo-elements in date/time inputs to ensure consistent height across browsers.\n*/\n\n  ::-webkit-datetime-edit-fields-wrapper {\n    padding: 0;\n  }\n\n  ::-webkit-datetime-edit,\n  ::-webkit-datetime-edit-year-field,\n  ::-webkit-datetime-edit-month-field,\n  ::-webkit-datetime-edit-day-field,\n  ::-webkit-datetime-edit-hour-field,\n  ::-webkit-datetime-edit-minute-field,\n  ::-webkit-datetime-edit-second-field,\n  ::-webkit-datetime-edit-millisecond-field,\n  ::-webkit-datetime-edit-meridiem-field {\n    padding-block: 0;\n  }\n\n  /*\n  Remove the additional `:invalid` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)\n*/\n\n  :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  /*\n  Correct the inability to style the border radius in iOS Safari.\n*/\n\n  button,\n  input:where([type=\"button\"], [type=\"reset\"], [type=\"submit\"]),\n  ::file-selector-button {\n    appearance: button;\n  }\n\n  /*\n  Correct the cursor style of increment and decrement buttons in Safari.\n*/\n\n  ::-webkit-inner-spin-button,\n  ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  /*\n  Make elements with the HTML hidden attribute stay hidden by default.\n*/\n\n  [hidden]:where(:not([hidden=\"until-found\"])) {\n    display: none !important;\n  }\n}\n\n@layer utilities {\n  @tailwind utilities;\n}\n","@import \"tailwindcss\";\n\n@layer base {\n  body {\n    @apply relative min-h-screen text-slate-900;\n  }\n  body::before {\n    @apply absolute inset-0 -z-2 bg-slate-900 content-[''];\n  }\n  body::after {\n    @apply absolute inset-0 -z-1 bg-white blur-sm content-[''] lg:blur-md;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4 {\n    @apply text-slate-950;\n  }\n  h2 {\n    @apply pt-20 text-2xl/snug font-semibold lg:text-5xl/snug;\n  }\n  h3 {\n    @apply text-xl font-medium lg:text-3xl;\n  }\n  h4 {\n    @apply mx-5 mt-6 justify-self-stretch border-l-3 py-1 pl-5 text-lg text-white lg:text-2xl;\n  }\n\n  figure {\n    @apply flex flex-col items-center;\n  }\n  figure > img {\n    @apply h-[30px] lg:h-[60px];\n  }\n\n  figcaption {\n    @apply text-center text-xs text-slate-500 lg:text-base;\n  }\n\n  address {\n    @apply mx-3 my-5 grid grid-cols-[repeat(auto-fill,minmax(150px,1fr))] gap-y-5 text-lg not-italic lg:mx-0;\n  }\n\n  address a {\n    @apply flex items-center gap-2;\n  }\n  address img {\n    @apply w-[30px];\n  }\n}\n\n@layer components {\n  .progress-bar::before {\n    @apply absolute inset-x-[15px] bottom-0 h-min border-b-[0.5px] border-slate-500/50 content-[''] lg:inset-x-[50px];\n  }\n  .progress-bar::after {\n    @apply absolute inset-x-[15px] bottom-0 h-[2px] bg-slate-950 content-[''] lg:inset-x-[50px];\n    transform-origin: center left;\n    animation: progress linear;\n    animation-timeline: scroll(root block);\n  }\n\n  .shadowing {\n    border: 1px solid rgba(255, 255, 255, 0.16);\n    box-shadow: 0 14px 30px rgba(15, 23, 42, 0.12);\n  }\n\n  .cta-button {\n    @apply inline-flex items-center justify-center rounded-lg border text-center font-medium transition-all duration-300 ease-in-out focus-visible:ring-2 focus-visible:ring-slate-950/25 focus-visible:ring-offset-2 focus-visible:ring-offset-white focus-visible:outline-none;\n    padding: 7px 25px;\n  }\n\n  .cta-button--primary {\n    @apply border-slate-500 bg-slate-500 text-white hover:-translate-y-0.5 hover:border-slate-600 hover:bg-slate-600;\n    box-shadow: none;\n  }\n\n  .cta-button--secondary {\n    @apply border-slate-400 bg-white/35 text-slate-900 hover:-translate-y-0.5 hover:bg-white/55;\n    backdrop-filter: blur(10px);\n    box-shadow: none;\n  }\n\n  .footer-pill {\n    @apply inline-block rounded-lg border border-slate-400 bg-white/35 text-xs text-slate-900 lg:text-base;\n    padding: 6px 25px;\n    backdrop-filter: blur(10px);\n    box-shadow:\n      inset 0 1px 3px rgba(255, 255, 255, 0.18),\n      0 4px 10px rgba(15, 23, 42, 0.1);\n  }\n\n  .separator {\n    @apply relative;\n  }\n  .separator::before {\n    @apply absolute inset-x-[40%] h-min border-t-[10px] border-double border-slate-500 content-[''];\n  }\n\n  #projects,\n  #blog,\n  #contact {\n    @apply px-[20px] lg:px-[100px];\n  }\n\n  #projects article {\n    @apply grid w-full max-w-[600px] items-start rounded-lg border border-white/10 bg-slate-500 text-white;\n    box-shadow: 0 16px 32px rgba(15, 23, 42, 0.08);\n  }\n  #projects > div {\n    @apply mx-1 grid justify-items-center gap-y-10 lg:mx-3;\n  }\n  #projects .embla__viewport {\n    @apply rounded-t-lg;\n  }\n\n  #projects article > ul {\n    @apply list-disc py-2 pr-5 pl-10 text-sm lg:text-base;\n  }\n\n  .project-actions {\n    @apply mx-4 grid gap-3 border-t border-white/20 pt-5 pb-5 text-base lg:mx-5 lg:grid-cols-2 lg:gap-4 lg:text-lg;\n  }\n\n  .project-action {\n    @apply inline-flex items-center justify-center gap-2 rounded-lg border px-4 py-2 text-center font-medium transition-all duration-300 ease-in-out focus-visible:ring-2 focus-visible:ring-white/70 focus-visible:ring-offset-2 focus-visible:ring-offset-slate-500 focus-visible:outline-none;\n  }\n\n  .project-action--primary {\n    @apply border-white bg-white text-slate-800 hover:-translate-y-0.5 hover:bg-slate-100;\n  }\n\n  .project-action--secondary {\n    @apply border-white/45 bg-white/10 text-white hover:-translate-y-0.5 hover:border-white/70 hover:bg-white/15;\n    backdrop-filter: blur(10px);\n  }\n\n  .project-action__icon {\n    @apply inline-block w-[18px] lg:w-[20px];\n    filter: brightness(0) saturate(100%);\n  }\n\n  .project-action i {\n    @apply text-lg lg:text-xl;\n  }\n\n  .white-icon {\n    filter: brightness(0) invert(1);\n    @apply inline-block w-[20px];\n  }\n\n  .big-icon {\n    filter: brightness(0) invert(1);\n    @apply inline-block w-[25px] lg:w-[30px];\n  }\n\n  #projects > h2,\n  #blog > h2 {\n    @apply w-[200px] border-b-[8px] border-slate-500 pb-3 whitespace-nowrap;\n  }\n\n  #projects h3 {\n    @apply m-5 w-[200px] rounded-tl-lg border-t-[6px] border-l-[6px] border-slate-500 py-3 pl-2 whitespace-nowrap lg:pl-5;\n  }\n\n  .project-tools {\n    @apply flex flex-wrap gap-x-3 gap-y-1 px-5 pb-2 text-base lg:gap-x-5 lg:gap-y-1 lg:pb-3 lg:text-lg;\n  }\n\n  .center-icon {\n    @apply flex items-center justify-center gap-[6px];\n  }\n\n  .blog-state {\n    @apply mx-1 mb-10 text-center text-base text-slate-700 lg:mx-3 lg:text-xl;\n  }\n\n  #blog-posts {\n    @apply mx-1 grid justify-items-center gap-y-10 lg:mx-3;\n  }\n\n  #blog article {\n    @apply w-full max-w-[600px] rounded-lg border border-white/10 bg-slate-500 text-white transition-all duration-300 ease-in-out hover:-translate-y-1 hover:bg-slate-600;\n    box-shadow: 0 16px 32px rgba(15, 23, 42, 0.08);\n  }\n\n  #blog article > a {\n    @apply block rounded-lg p-4 lg:p-6;\n  }\n\n  #blog article > a:focus-visible {\n    @apply rounded-lg ring-2 ring-white ring-offset-2 ring-offset-slate-500 outline-none;\n  }\n\n  #blog article h3 {\n    @apply text-2xl/snug font-semibold text-white transition-all duration-300 lg:text-3xl/snug;\n  }\n\n  #blog article:hover h3 {\n    @apply underline underline-offset-4;\n  }\n\n  .blog-card__meta {\n    @apply mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-sm text-slate-100 lg:text-base;\n  }\n\n  .blog-card__separator {\n    @apply text-slate-300;\n  }\n\n  .blog-card__subtitle {\n    @apply mt-2 text-base/relaxed text-slate-50 lg:text-lg/relaxed;\n  }\n\n  .embla {\n    position: relative;\n  }\n\n  .embla__viewport {\n    overflow: hidden;\n  }\n\n  .embla__container {\n    display: flex;\n    touch-action: pan-y pinch-zoom;\n  }\n\n  .embla__slide {\n    flex: 0 0 100%;\n    min-width: 0;\n    object-fit: cover;\n  }\n\n  .embla__prev {\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n  }\n\n  .embla__next {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n  }\n}\n\n@keyframes progress {\n  from {\n    transform: scaleX(0);\n  }\n}\n\n/* Uncomment the following css normalize and reset stylesheet when writing vanilla css */\n\n/* normalize stylesheet */\n/* @import \"../node_modules/modern-normalize/modern-normalize.css\"; */\n\n/* reset stylesheet */\n/* :root {\n  line-height: 1.5;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nfigure,\np,\nol,\nul {\n  margin: 0;\n}\n\nol[role=\"list\"],\nul[role=\"list\"] {\n  list-style: none;\n  padding-inline: 0;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5 {\n  font-size: inherit;\n  font-weight: inherit;\n}\n\nimg {\n  display: block;\n  max-inline-size: 100%;\n} */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
